"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Client implementation of X++ TaskRecorderState control.
         * Used to communicate the state of the recording and playback process from the server.
         */
        var TaskRecorderState = /** @class */ (function (_super) {
            __extends(TaskRecorderState, _super);
            function TaskRecorderState(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                $dyn.ax.taskRecording.taskRecorderStateControl = _this;
                _this.taskRecorderController = $dyn.ax.taskRecording.taskRecorderController;
                _this.taskRecorderController.GuidedStep = _this.GuidedStep;
                // Subscribe to skip back trigger
                $dyn.observe(_this.taskRecorderController.skipBackGuidedStepTrigger, function () {
                    $dyn.applyFunction(_this.SkipBackStep, _this);
                });
                // Subscribe to skip trigger
                $dyn.observe(_this.taskRecorderController.skipGuidedStepTrigger, function () {
                    $dyn.applyFunction(_this.SkipStep, _this);
                });
                // Observe recording and playback states
                $dyn.observe(_this.RecordingState, $dyn.ax.taskRecording._handleServerRecordingStateChanged);
                // Observe the discrete mode state, whether to show the toolbar or not
                $dyn.observe(function () {
                    return $dyn.value($dyn.ax.taskRecording.started) && !$dyn.value(_this.InDiscreteMode);
                }, function (showToolbar) {
                    if (showToolbar) {
                        // Delay the addidion of the toolbar in case the discrete mode is about to change to true
                        // to avoid adding and immediately removing the toolbar, causing a visual bug
                        $dyn.async(function () {
                            if (!$dyn.value(_this.InDiscreteMode)) {
                                $dyn.ax.taskRecording.addToolbar();
                            }
                        });
                    }
                    else {
                        $dyn.ax.taskRecording.removeToolbar();
                    }
                });
                // Observe the task guide playback state
                $dyn.observe(_this.TaskGuidePlaybackState, function (value) {
                    if (value) {
                        _this.taskRecorderController.initTaskGuide(false);
                    }
                    else {
                        _this.taskRecorderController.disposeTaskGuide();
                    }
                    $dyn.ax.taskRecording.taskGuidePlaybackState(value);
                    $dyn.ax.taskRecording.taskGuideRailsMode(value);
                });
                _this.pingPending = 0;
                $dyn.observe(_this.TaskName, function (name) {
                    var toolbar = $dyn.ax.taskRecording._toolbar;
                    if (toolbar) {
                        $(".taskRecorderToolbar-stepContext", toolbar).animate({ opacity: 0 }, {
                            complete: function () {
                                $dyn.ax.taskRecording.currentTask(name);
                                $(".taskRecorderToolbar-stepContext", toolbar).animate({ opacity: 1 });
                            }
                        });
                    }
                    else {
                        $dyn.ax.taskRecording.currentTask(name);
                    }
                });
                $dyn.ax.taskRecording.isRecording(true);
                $dyn.observe(_this.PlaybackState, function (newState) {
                    if ($dyn.ax.taskRecording._playbackState === newState) {
                        // State didn't change, no need to do anything
                        return;
                    }
                    $dyn.ax.taskRecording._playbackState = newState;
                    if (_this.isPlaybackRunning()) {
                        $dyn.ax.taskRecording.isRecording(false);
                        _this.continuePlayback($dyn.value(_this.PlaybackSequence));
                    }
                    else {
                        $dyn.ax.taskRecording.isRecording($dyn.value($dyn.ax.taskRecording.started));
                    }
                });
                $dyn.observe(_this.PlaybackSequence, function (newSequence) {
                    // An update to playback sequence means server acknowledged previous playbak-continue request
                    // Let's check if the playback is still happenign and request to continue again
                    if (_this.lastSequence !== newSequence) {
                        _this.lastSequence = newSequence;
                        _this.continuePlayback(newSequence);
                    }
                });
                // Observe ping sequence and queue new pings
                $dyn.observe(_this.PingSequence, function (newSequence) {
                    if (_this.lastPingSequence !== newSequence) {
                        _this.lastPingSequence = newSequence;
                        _this.pingServer(newSequence);
                    }
                });
                // Observe edit mode and make the TR pane active
                $dyn.observe(_this.InEditMode, function (inEditMode) {
                    if (inEditMode === true) {
                        _this.previousActiveForm = $dyn.shell.getActiveForm();
                        if (_this.previousActiveForm !== _this.Root.element && $(_this.Root.element).closest(_this.previousActiveForm).length === 0) {
                            $dyn.shell.activateElement(_this.Root.element);
                        }
                    }
                    else if (inEditMode === false) {
                        if (_this.previousActiveForm) {
                            $dyn.shell.activateElement(_this.previousActiveForm);
                            _this.previousActiveForm = null;
                        }
                    }
                });
                // Observe the task guide pane ID and save the form
                $dyn.observe(_this.TaskGuidePaneId, function (newId) {
                    if (!newId && $dyn.ax.taskRecording.runningTaskGuidePane) {
                        // Whatever pane we had previously needs to be unpinned as newID is null
                        _this.releaseTaskGuideForm($dyn.ax.taskRecording.runningTaskGuidePane);
                        $dyn.ax.taskRecording.runningTaskGuidePane = undefined;
                    }
                    else {
                        // Find the form based on the new ID
                        if ($dyn.serverForm && $dyn.serverForm.defaultChannel && $dyn.serverForm.interactionHandler) {
                            var interactionChannel = $dyn.serverForm.defaultChannel();
                            // We only need to look into the current window since pane cannot appear in a popup
                            var interactionHandler = $dyn.serverForm.interactionHandler;
                            var formElement = interactionHandler.getFormElement(newId + " " + interactionChannel.channel.channelId);
                            if ($dyn.ax.taskRecording.runningTaskGuidePane !== formElement) {
                                // Release previous task guide form - if exists
                                if ($dyn.ax.taskRecording.runningTaskGuidePane) {
                                    _this.releaseTaskGuideForm($dyn.ax.taskRecording.runningTaskGuidePane);
                                }
                                // Now deal with the new one - make it current
                                $dyn.ax.taskRecording.runningTaskGuidePane = formElement;
                                if (formElement) {
                                    // Prevent this form from being auto closed
                                    $dyn.context(formElement).PreventAutoClose(true);
                                }
                            }
                        }
                    }
                });
                return _this;
            }
            TaskRecorderState.prototype.stopSession = function () {
                var _this = this;
                // Sends the stop session command to the server.
                // Wait till client is not busy and the taskRecorder started state is false.
                $dyn.observe($dyn.clientBusy, function (clientBusy) {
                    if (!clientBusy) {
                        $dyn.applyFunction(_this.StopSession, _this);
                        return false;
                    }
                });
            };
            /** Gets if the playback is still running in server */
            TaskRecorderState.prototype.isPlaybackRunning = function () {
                return ($dyn.ax.taskRecording._playbackState === "Running");
            };
            /**
             * Gets if the playback is on
             *
             * @deprecated This is deprecated at 09/11/2020.
             */
            TaskRecorderState.prototype.isPlaybackOn = function () {
                return ($dyn.ax.taskRecording._playbackState !== "Off");
            };
            /** Continues the playback */
            TaskRecorderState.prototype.continuePlayback = function (sequenceNum) {
                var _this = this;
                // Give a delay timeout to slow down the playback let the effects be visible
                $dyn.async(function () {
                    // Wait till client is not busy
                    $dyn.observe($dyn.clientBusy, function (isBusy) {
                        if (isBusy === false) {
                            if ($dyn.value($dyn.clientInError)) {
                                // We are in error, pause the playback
                                $dyn.applyFunction(_this.PausePlayback, _this);
                            }
                            else if (_this.isPlaybackRunning()) {
                                $dyn.callFunction(_this.ContinuePlayback, _this, [sequenceNum]);
                            }
                            // No need to observe anymore
                            return false;
                        }
                    });
                }, 400, "Task recorder continue playback");
            };
            /** Ping server */
            TaskRecorderState.prototype.pingServer = function (sequenceNum) {
                var _this = this;
                this.pingPending++;
                this.taskRecorderController.serverUpdatePending(this.pingPending > 0);
                // Give a delay timeout to slow down the playback let the effects be visible
                $dyn.async(function () {
                    // Wait till client is not busy
                    $dyn.observe($dyn.clientBusy, function (isBusy) {
                        if (isBusy === false) {
                            $dyn.callFunction(_this.ClientPing, _this, [sequenceNum], function () {
                                // Callback when ping is done
                                _this.pingPending--;
                                _this.taskRecorderController.serverUpdatePending(_this.pingPending > 0);
                            });
                            // No need to observe anymore
                            return false;
                        }
                    });
                }, 50, "Task recorder ping server");
            };
            // Release the task guide form so that it can be auto closed
            TaskRecorderState.prototype.releaseTaskGuideForm = function (formElement) {
                if (formElement) {
                    $dyn.context(formElement).PreventAutoClose(false);
                    // If it is not the active aside form, close it
                    if ($dyn.shell.getActiveAsideForm() !== formElement) {
                        $dyn.applyFunction($dyn.context(formElement).Close);
                    }
                }
            };
            return TaskRecorderState;
        }($dyn.ui.Control));
        controls.TaskRecorderState = TaskRecorderState;
        TaskRecorderState.prototype.RecordingState = "";
        TaskRecorderState.prototype.PlaybackState = "";
        TaskRecorderState.prototype.StopRecording = undefined;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=TaskRecorderState.js.map
